import _ from 'lodash';

const MAX_AVATARS = 4;

class EventGroupViewModel {
  constructor(group, key, collapsible) {
    this.key = key;
    this.groupKey = group.key;
    this.titleId = group.titleId;
    this.panelStyle = group.panelStyle;
    this.collapsible = collapsible;
    this.events = [];
  }

  get count() {
    return this.events.length;
  }

  get employees() {
    return _.chain(this.events).map('subjectEmployee').compact().uniqBy('id').value();
  }

  get avatarLimit() {
    return this.employees.length > MAX_AVATARS ? MAX_AVATARS - 1 : MAX_AVATARS;
  }

  add(event) {
    this.events.push(event);
  }
}

export default EventGroupViewModel;
